import { useEffect, useState } from "react";
import { toast } from "sonner";
import { listProdotti, upsertProdotto, OBIETTIVO_LABEL } from "./clubApi";
import { Btn, Card, Field, inputCls, Pill } from "./ui";

const EMPTY = { nome: "", durata_giorni: 30, dose: "", obiettivi: [], attivo: true };

export default function Catalogo() {
  const [rows, setRows] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => listProdotti().then(setRows).catch(() => toast.error("Catalogo non caricato"));
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (!edit.nome.trim()) return toast.error("Serve il nome");
    try { await upsertProdotto({ ...edit, durata_giorni: Number(edit.durata_giorni) || 30 }); toast.success("Prodotto salvato"); setEdit(null); load(); } catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
  };
  const toggleOb = (k) => setEdit({ ...edit, obiettivi: edit.obiettivi.includes(k) ? edit.obiettivi.filter((x) => x !== k) : [...edit.obiettivi, k] });
  return (
    <div className="mt-6" data-testid="catalogo">
      <div className="flex items-center justify-between">
        <p className="text-sm text-[#9A948A]">Durate e abbinamenti sono indicativi e modificabili. Nessuna indicazione terapeutica.</p>
        <Btn variant="dark" className="px-4 py-2 text-xs" onClick={() => setEdit({ ...EMPTY })} data-testid="new-product-btn">+ Prodotto</Btn>
      </div>
      {edit && (
        <Card className="mt-4 space-y-4" data-testid="product-editor">
          <Field label="Nome"><input className={inputCls} value={edit.nome} onChange={(e) => setEdit({ ...edit, nome: e.target.value })} data-testid="product-nome" /></Field>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Durata (giorni)"><input className={inputCls} type="number" value={edit.durata_giorni} onChange={(e) => setEdit({ ...edit, durata_giorni: e.target.value })} data-testid="product-durata" /></Field>
            <Field label="Attivo"><select className={inputCls} value={edit.attivo ? "1" : "0"} onChange={(e) => setEdit({ ...edit, attivo: e.target.value === "1" })}><option value="1">Sì</option><option value="0">No</option></select></Field>
          </div>
          <Field label="Come si usa"><input className={inputCls} value={edit.dose} onChange={(e) => setEdit({ ...edit, dose: e.target.value })} data-testid="product-dose" /></Field>
          <div>
            <p className="mb-2 text-[0.7rem] uppercase tracking-[0.18em] text-[#9A948A]">Obiettivi collegati</p>
            <div className="flex flex-wrap gap-2">
              {[...Object.keys(OBIETTIVO_LABEL), "alimentazione", "base"].map((k) => (
                <button key={k} type="button" onClick={() => toggleOb(k)} className={`rounded-full border px-3 py-1 text-xs ${edit.obiettivi.includes(k) ? "border-[#E5B13A] text-[#F5D27A] bg-[#E5B13A]/10" : "border-[#2E2E34] text-[#9A948A]"}`}>{OBIETTIVO_LABEL[k] || k}</button>
              ))}
            </div>
          </div>
          <div className="flex gap-2"><Btn onClick={save} data-testid="product-save">Salva</Btn><Btn variant="ghost" onClick={() => setEdit(null)}>Annulla</Btn></div>
        </Card>
      )}
      <div className="mt-4 space-y-2">
        {rows.map((p) => (
          <button key={p.codice} onClick={() => setEdit({ ...p })} data-testid={`product-row-${p.codice}`} className={`w-full text-left rounded-2xl border border-[#26262B] bg-[#141417] p-4 hover:border-[#E5B13A]/50 ${p.attivo ? "" : "opacity-50"}`}>
            <div className="flex items-center justify-between gap-3">
              <div className="min-w-0"><p className="font-medium text-sm truncate">{p.nome}</p><p className="text-xs text-[#9A948A] mt-0.5">{p.durata_giorni} giorni · {p.dose}</p></div>
              <div className="flex gap-1 flex-wrap justify-end">{p.obiettivi.slice(0, 3).map((o) => <Pill key={o} tone="muted">{OBIETTIVO_LABEL[o] || o}</Pill>)}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
